

















































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { doublePrevention } from '@/api/installServer';
import { deepClone } from '@/util/deepClone';

@Component({
  components: { CollapseTransition, PagingUnit },
  mixins: [TableStripe],
})
export default class InspectionContents extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 总共多少条数据

  private table: any = {
    list: [],
    statusList: [],
    selectList: [],
    pageNo: 1,
    pageSize: 10,
    total: 0,
    loading: false,
  };
  private data = {};
  private filterForm = {
    search: '',
  };

  created() {
    this.getConfigList();
  }

  /**
   * 查询
   */
  handleSearch(data: any) {
    this.getConfigList();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.filterForm = {
      search: '',
    };
    this.getConfigList();
  }

  private getListData() {
    this.getConfigList();
  }

  /**
   * 【表格】表格编辑/保存按钮
   */
  async handleTableEditBtnClick(data: any) {
    this.data = deepClone(data);
    const index: string = this.getListIndexByid(data.id);
    switch (this.table.statusList[index]) {
      case true: // 保存
        this.table.statusList[index] = false;
        await this.editConfigData(data);
        this.getConfigList();
        break;
      case false: // 取消
        this.table.statusList[index] = true;
        break;
    }
    const list = this.table.list;
    this.table.list = [];
    this.table.list = list;
  }

  /**
   * 【表格】表格取消按钮
   */
  async handleTableCancelBtnClick(data: any) {
    const index: string = this.getListIndexByid(data.id);
    this.table.statusList[index] = false;
    this.table.list[index] = this.data;
    const list = this.table.list;
    this.table.list = [];
    this.table.list = list;
  }

  /**
   *【分页】分页变化
   * @Params
   * @return
   **/
  handlePaginationCurrentChange(pageNo: number) {
    this.table.pageNo = pageNo;
    this.getConfigList();
  }

  /**
   *【分页】分页大小变化
   * @Params
   * @return
   **/
  handlePaginationSizeChange(pageSize: number) {
    this.table.pageSize = pageSize;
    this.getConfigList();
  }

  /**
   * 【按钮】批量操作指令
   */
  handleBatchCommand(command: string) {
    if (this.table.selectList.length === 0) {
      this.$message.warning('请选择您要操作的数据。');
      return;
    }
    switch (command) {
      case 'remove':
        // this.handleBatchRemove();
        break;
    }
  }

  /**
   * 【表格】表格选择记录变化
   */
  handleTableSelectionChange(val: any) {
    this.table.selectList = val;
  }

  /**
   *【接口】获取配置列表
   * @Params
   * @return
   **/
  async getConfigList(pageNo?: number) {
    this.table.loading = true;
    (this.queryDataForm as any).pageNo = pageNo || (this.queryDataForm as any).pageNo;
    try {
      const res: any = await doublePrevention.getPointConfig({
        type: '1',
        search: this.filterForm.search,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
      });
      if (res.code == 200) {
        this.table.list = res.data.records;
        this.total = res.data.total;
        this.table.loading = false;
        this.status2list(res.data.records);
      } else {
        this.$message.warning(res.msg);
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】编辑规则
   */
  async editConfigData(data: any) {
    try {
      const res: any = await doublePrevention.editPointConfig({
        id: data.id,
        configId: data.configId,
        spaceId: data.spaceId,
        name: data.name,
        num: data.num,
        enable: data.enable,
        doubleMulValue: data.doubleMulValue,
        doubleFlag: data.doubleFlag,
      });
      if (res.code == 200) {
        this.$message.success('您成功编辑记录。');
      } else {
        this.$message.warning(res.msg);
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【方法】创造表格行的状态列表（编辑/查看）
   */
  private status2list(data: any) {
    this.table.statusList = [];
    for (let i = 0, len = data.length; i < len; i++) this.table.statusList.push(false);
  }

  /**
   * 【事件】是否有行被点击
   */
  private hasRowClick(data: any) {
    let result = false;
    this.table.statusList.forEach((t: any, i: number) => {
      if (t && i.toString() != this.getListIndexByid(data.id)) {
        result = t;
      }
    });
    return result;
  }

  /**
   * 【方法】通过id获取下标
   */
  private getListIndexByid(id: string): string {
    return this.table.list
      .findIndex((credit: any) => {
        return credit.id == id;
      })
      .toString();
  }
}
